module.exports = __webpack_public_path__ + "static/media/vacuum cleaner.26fd366b.svg";